import React from "react";
import styles from "./style.module.css";

export default class AlertComparison extends React.Component {
  render() {
    return (
      <div>
        <div>{"Monthly Transactions"}</div>
        <div>
          <div className={styles.comparisonLabels}>
            <div>{"Expected"}</div>
            <div>{"Actual"}</div>
          </div>
          <div className={styles.compareBarData}></div>
        </div>
      </div>
    );
  }
}
